module.exports = __webpack_public_path__ + "static/media/penalty.svg.d61aa7e8.png";